// Smart Sash Admin Panel - Login Page
// Main login page with form

import { LoginForm } from '@/components/auth/LoginForm';
import { useAuth } from '@/services/auth';
import React, { useEffect } from 'react';
import { useLocation, useNavigate } from 'react-router-dom';

/**
 * Login Page Component
 */
export const Login: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const { isAuthenticated, requiresPasswordChange } = useAuth();

  // Redirect to original destination or dashboard if already authenticated
  useEffect(() => {
    if (requiresPasswordChange) {
      navigate('/change-password', { replace: true });
      return;
    }

    if (isAuthenticated) {
      const from =
        (location.state as { from?: { pathname: string } })?.from?.pathname || '/dashboard';
      navigate(from, { replace: true });
    }
  }, [isAuthenticated, requiresPasswordChange, navigate, location]);

  return (
    <div className="min-vh-100 d-flex align-items-center justify-content-center bg-light">
      <div className="container">
        <div className="row justify-content-center">
          <div className="col-md-6 col-lg-5">
            <div className="card shadow-lg border-0">
              <div className="card-body p-5">
                {/* Header */}
                <div className="text-center mb-4">
                  <h1 className="h3 mb-3 fw-bold">SmartSash Portal</h1>
                  <p className="text-muted">Sign in to your account</p>
                </div>

                {/* Login Form */}
                <LoginForm />

                {/* Footer */}
                <div className="text-center mt-4 pt-4 border-top">
                  <p className="text-muted small mb-0">
                    &copy; {new Date().getFullYear()} H. H. Hawkins Ltd.
                  </p>
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Login;
